import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Landing from '../pages/Landing';
import Login from '../pages/Login';
import Register from '../pages/Register';
import ForgotPassword from '../pages/ForgotPassword';
import Workspace from '../pages/Workspace';
import NotFound from '../pages/NotFound';
import Profile from '../pages/Profile';
import { useAuth } from '../contexts/AuthContext';

// Simple Protected Route helper
const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f9fafb'
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #e5e7eb',
          borderTopColor: '#3b82f6',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export const AppRouter: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        {/* Workspace & Tabs - Protected Routes */}
        <Route path="/workspace" element={<ProtectedRoute><Workspace /></ProtectedRoute>} />
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
        <Route path="/dashboard" element={<ProtectedRoute><Workspace initialTab="dashboard" /></ProtectedRoute>} />
        <Route path="/crm" element={<ProtectedRoute><Workspace initialTab="crm" /></ProtectedRoute>} />
        <Route path="/students" element={<ProtectedRoute><Workspace initialTab="students" /></ProtectedRoute>} />
        <Route path="/faculty" element={<ProtectedRoute><Workspace initialTab="faculty" /></ProtectedRoute>} />
        <Route path="/courses" element={<ProtectedRoute><Workspace initialTab="courses" /></ProtectedRoute>} />
        <Route path="/payments" element={<ProtectedRoute><Workspace initialTab="payments" /></ProtectedRoute>} />
        <Route path="/analytics" element={<ProtectedRoute><Workspace initialTab="analytics" /></ProtectedRoute>} />
        <Route path="/builder" element={<ProtectedRoute><Workspace initialTab="builder" /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Workspace initialTab="settings" /></ProtectedRoute>} />
        <Route path="/notifications" element={<ProtectedRoute><Workspace initialTab="notifications" /></ProtectedRoute>} />

        {/* 404 Fallback */}
        <Route path="/404" element={<NotFound />} />
        <Route path="*" element={<Navigate to="/404" replace />} />
      </Routes>
    </BrowserRouter>
  );
};

export default AppRouter;
